import { LevelData } from '../level-data';

export const level5: LevelData = {
    name: 'Slow Down',
    timeLimit: 75,
    track: [
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '---S---',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '---S---',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        'FFFFFFF',
    ],
};
